import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { MaintenanceService } from './maintenance.service';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {

    constructor(private _maintenanceService: MaintenanceService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event) => {
                if (event instanceof HttpResponse) {
                    const body = event.body;

                    // Verifica se é resposta de manutenção
                    if (body && body.success === false && body.code === 'MAINTENANCE') {
                        this._maintenanceService.showMaintenanceModal();
                    }
                }
            })
        );
    }
}
